import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { NotificationType } from './notification-type.enum';
import { NotificationData } from '../models/notifications.model';

@Injectable({
  providedIn: 'root',
})
export class NotificationNavigationService {
  constructor(private router: Router) {}

  navigate(type?: string, data?: NotificationData, username?: string): void {
    console.log('Notification type:', type);
    console.log('Notification data:', data);

    switch (type) {
      // --------------------
      // Project
      // --------------------
      case NotificationType.ProjectRejected:
        this.router.navigate(['/client/project/edit', data?.id]);
        break;

      case NotificationType.ProjectApproved:
      case NotificationType.ProjectSubmittedForReview:
      case NotificationType.ProjectDeletedByAdmin:
      case NotificationType.ProjectCancelledBySp:
      case NotificationType.ProjectDisputeRaisedByClient:
      case NotificationType.ClientProjectDisputeRaisedBySp:
      case NotificationType.ProjectDeliverablesSubmitted:
      case NotificationType.ProjectDeliverablesUpdated:
      case NotificationType.ProjectDeliverablesAccepted:
      case NotificationType.ProjectDeliverablesAutoApproved:
      case NotificationType.ProjectDisputeResolved:
      case NotificationType.ProjectReviewRequest:
      case NotificationType.ProjectReviewSubmitted:
      case NotificationType.ProjectReportConfirmation:
      case NotificationType.ProjectReportNoViolation:
        this.router.navigate(['/client/project', data?.id]);
        break;

      // --------------------
      // Project - Proposal tab
      // --------------------

      case NotificationType.ProposalReceived:
      case NotificationType.ProposalAccepted:
      case NotificationType.ProposalNotSelected:
        this.router.navigate(['/client/project', data?.id], {
          state: { tab: 'proposals' },
        });
        break;
      // --------------------
      // Service
      // --------------------
      case NotificationType.ServiceApproved:
      case NotificationType.ServiceSubmitted:
      case NotificationType.ServiceReportConfirmation:
      case NotificationType.ServiceReportNoViolation:
        this.router.navigate(['/service', data?.id]);
        break;

      case NotificationType.ServiceRejected:
        this.router.navigate(['/create/service', data?.id]);
        break;

      case NotificationType.ClientServiceRequestSent:
      case NotificationType.ServiceRequestReceived:
      case NotificationType.ClientServiceRequestAccepted:
      case NotificationType.ClientServiceRequestDeclined:
      case NotificationType.ClientServiceRequestAutoCancelled:
      case NotificationType.ServiceRequestAutoCancelled:
      case NotificationType.ClientServiceRequestCancelledBySp:
      case NotificationType.ServiceRequestCancelledByClient:
      case NotificationType.ClientServiceRequestDisputeRaisedBySp:
        this.router.navigate(['/service/request', data?.id]);
        break;

      // --------------------
      // Service Request
      // --------------------

      case NotificationType.ServiceRequestDisputeRaisedByClient:
      case NotificationType.ServiceRequestDeliverablesSubmitted:
      case NotificationType.ServiceRequestDeliverablesAccepted:
      case NotificationType.ServiceRequestDeliverablesAutoApproved:
      case NotificationType.ServiceRequestDisputeResolved:
      case NotificationType.ServiceRequestReviewRequest:
      case NotificationType.ServiceRequestReviewSubmitted:
        this.router.navigate(['/service/request', data?.id]);
        break;

      // --------------------
      // Portfolio
      // --------------------

      case NotificationType.PortfolioApproved:
        this.router.navigate(['/project', data?.id]);
        break;

      case NotificationType.PortfolioRejected:
      case NotificationType.PortfolioDeletedByAdmin:
        if (username) {
          this.router.navigate(['/edit-portfolio-project', data?.id]);
        }
        break;

      case NotificationType.IdentityApproved:
      case NotificationType.IdentityRejected:
        this.router.navigate(['/settings/identify-validation']);
        break;

      case NotificationType.CommentReportConfirmation:
      case NotificationType.CommentReportNoViolation:
      case NotificationType.PostReportConfirmation:
      case NotificationType.PostReportNoViolation:
        this.router.navigate(['/timeline'], {
          queryParams: {
            postId: data?.id,
          },
        });
        break;
      // --------------------
      // No navigation
      // --------------------
      case NotificationType.Welcome:
      case NotificationType.PasswordChanged:
      case NotificationType.DailyProposalLimitReached:
      case NotificationType.PostRejected:
      case NotificationType.PostDeletedByAdmin:
      case NotificationType.CommentRejected:
      case NotificationType.CommentDeletedByAdmin:
      case NotificationType.PaymentReleased:
      case NotificationType.PaymentRefunded:
      case NotificationType.ProjectReportPermanentRemoval:
      case NotificationType.ServiceReportPermanentRemoval:
      case NotificationType.CommentReportPermanentRemoval:
      case NotificationType.PostReportPermanentRemoval:
      case NotificationType.ServiceDeletedByAdmin:
      case NotificationType.PortfolioSubmitted:
      case NotificationType.PostReportEditRequired:
      case NotificationType.CommentReportEditRequired:
      case NotificationType.ProjectReportEditRequired:
      case NotificationType.ServiceReportEditRequired:
      case NotificationType.PortfolioReported:
      case NotificationType.ProjectReported:
        break;
    }
  }
}
